import checkout from "../../api/checkout";

const state = {
  contact: {
    fullName: "",
    email: "",
    contactNumber: ""
  },
  billing: {
    firstName: "",
    lastName: "",
    contactNumber: "",
    unit: "",
    barangay: "",
    city: "",
    province: "",
    postalCode: "",
    country: "PH"
  },
  shipping: {
    firstName: "",
    lastName: "",
    contactNumber: "",
    unit: "",
    barangay: "",
    city: "",
    province: "",
    postalCode: "",
    country: "PH",
    method: "",
    fee: null
  },
  isAuthUser: false,
  instructions: "",
  deliveryMethod: "",
  pickupLocation: "",
  pickupLocationAddress: "",
  paymentMethod: "",
  steps: {
    cart: false,
    information: false,
    shipping: false,
    payment: false
  },
  voucher: "",
  discount: null,
  subscribeToNewsLetter: false,
  couponinfo: null
};

const getters = {
  fullShippingAddress: ({ shipping }) =>
    shipping.unit +
    ", " +
    shipping.barangay +
    ", " +
    shipping.city +
    ", " +
    shipping.province +
    " " +
    shipping.postalCode +
    ", " +
    shipping.country,
  fullbillingAddress: ({ billing }) =>
    billing.unit +
    ", " +
    billing.barangay +
    ", " +
    billing.city +
    ", " +
    billing.province +
    " " +
    billing.postalCode +
    ", " +
    billing.country,
  paymentPayload: state => {
    let payload = {
      contact: state.contact,
      instructions: state.instructions,
      delivery_method: state.deliveryMethod,
      subscribe_to_newsletter: state.subscribeToNewsletter,
      voucher: state.voucher
    };

    if (state.deliveryMethod === "shipping") {
      payload.shipping = state.shipping;
      payload.billing = state.billing;
    }

    if (state.deliveryMethod === "pickup") {
      payload.pickup_location = state.pickupLocation;
    }

    return payload;
  }
};

const actions = {
  loadContact({ commit }, payload = {}) {
    const {
      fullName = "",
      email = "",
      contactNumber = "",
      isAuthUser = false
    } = payload;

    commit("UPDATE_CONTACT_FULL_NAME", fullName);
    commit("UPDATE_CONTACT_EMAIL", email);
    commit("UPDATE_CONTACT_NUMBER", contactNumber);
    commit("UPDATE_IS_AUTH_USER", isAuthUser);
  },
  loadBilling({ commit }, payload = {}) {
    const {
      firstName = "",
      lastName = "",
      contactNumber = "",
      unit = "",
      barangay = "",
      city = "",
      province = "",
      postalCode = "",
      country = "PH"
    } = payload;

    commit("UPDATE_BILLING_FIRST_NAME", firstName);
    commit("UPDATE_BILLING_LAST_NAME", lastName);
    commit("UPDATE_BILLING_CONTACT_NUMBER", contactNumber);
    commit("UPDATE_BILLING_UNIT", unit);
    commit("UPDATE_BILLING_BARANGAY", barangay);
    commit("UPDATE_BILLING_CITY", city);
    commit("UPDATE_BILLING_PROVINCE", province);
    commit("UPDATE_BILLING_POSTAL_CODE", postalCode);
    commit("UPDATE_BILLING_COUNTRY", country);
  },
  loadShipping({ commit }, payload = {}) {
    const {
      firstName = "",
      lastName = "",
      contactNumber = "",
      unit = "",
      barangay = "",
      city = "",
      province = "",
      postalCode = "",
      country = "PH"
    } = payload;

    commit("UPDATE_SHIPPING_FIRST_NAME", firstName);
    commit("UPDATE_SHIPPING_LAST_NAME", lastName);
    commit("UPDATE_SHIPPING_CONTACT_NUMBER", contactNumber);
    commit("UPDATE_SHIPPING_UNIT", unit);
    commit("UPDATE_SHIPPING_BARANGAY", barangay);
    commit("UPDATE_SHIPPING_CITY", city);
    commit("UPDATE_SHIPPING_PROVINCE", province);
    commit("UPDATE_SHIPPING_POSTAL_CODE", postalCode);
    commit("UPDATE_SHIPPING_COUNTRY", country);
  },
  async computeDiscount({ commit, getters }) {
    const {
      data: { discount }
    } = await checkout.computeDiscount(getters.paymentPayload);

    commit("UPDATE_DISCOUNT", discount);
  }
};

const mutations = {
  UPDATE_CONTACT_FULL_NAME: (state, data) => (state.contact.fullName = data),
  UPDATE_CONTACT_EMAIL: (state, data) => (state.contact.email = data),
  UPDATE_CONTACT_NUMBER: (state, data) => (state.contact.contactNumber = data),

  UPDATE_BILLING_FIRST_NAME: (state, data) => (state.billing.firstName = data),
  UPDATE_BILLING_LAST_NAME: (state, data) => (state.billing.lastName = data),
  UPDATE_BILLING_CONTACT_NUMBER: (state, data) =>
    (state.billing.contactNumber = data),
  UPDATE_BILLING_UNIT: (state, data) => (state.billing.unit = data),
  UPDATE_BILLING_BARANGAY: (state, data) => (state.billing.barangay = data),
  UPDATE_BILLING_CITY: (state, data) => (state.billing.city = data),
  UPDATE_BILLING_PROVINCE: (state, data) => (state.billing.province = data),
  UPDATE_BILLING_POSTAL_CODE: (state, data) =>
    (state.billing.postalCode = data),
  UPDATE_BILLING_COUNTRY: (state, data) => (state.billing.country = data),

  UPDATE_SHIPPING_FIRST_NAME: (state, data) =>
    (state.shipping.firstName = data),
  UPDATE_SHIPPING_LAST_NAME: (state, data) => (state.shipping.lastName = data),
  UPDATE_SHIPPING_CONTACT_NUMBER: (state, data) =>
    (state.shipping.contactNumber = data),
  UPDATE_SHIPPING_UNIT: (state, data) => (state.shipping.unit = data),
  UPDATE_SHIPPING_BARANGAY: (state, data) => (state.shipping.barangay = data),
  UPDATE_SHIPPING_CITY: (state, data) => (state.shipping.city = data),
  UPDATE_SHIPPING_PROVINCE: (state, data) => (state.shipping.province = data),
  UPDATE_SHIPPING_POSTAL_CODE: (state, data) =>
    (state.shipping.postalCode = data),
  UPDATE_SHIPPING_COUNTRY: (state, data) => (state.shipping.country = data),
  UPDATE_SHIPPING_METHOD: (state, data) => (state.shipping.method = data),
  UPDATE_SHIPPING_FEE: (state, data) => (state.shipping.fee = data),

  UPDATE_IS_AUTH_USER: (state, data) => (state.isAuthUser = data),
  UPDATE_INSTRUCTIONS: (state, data) => (state.instructions = data),
  UPDATE_DELIVERY_METHOD: (state, data) => (state.deliveryMethod = data),
  UPDATE_PICKUP_LOCATION: (state, data) => (state.pickupLocation = data),
  UPDATE_PICKUP_LOCATION_ADDRESS: (state, data) =>
    (state.pickupLocationAddress = data),
  UPDATE_PAYMENT_METHOD: (state, data) => (state.paymentMethod = data),
  UPDATE_STEP_COMPLETED: (state, step) => (state.steps[step] = true),
  UPDATE_DISCOUNT: (state, data) => (state.discount = data),
  UPDATE_SUBSCRIBE_TO_NEWS_LETTER: (state, data) =>
    (state.subscribeToNewsletter = data),
  UPDATE_COUPON: (state, data) => (state.voucher = data),
  SET_COUPONINFO: (state, data) => (state.couponinfo = data),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
